import { Injectable,isDevMode } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import { AppComponent } from '../app.component';


const API_WINKELS_ENDPOINT = '/category';


@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  constructor(private http: HttpClient) { }

  getCategories(): Observable<any> {
    return this.http.get(AppComponent.baseUrl + API_WINKELS_ENDPOINT+ '/overview', { responseType: 'text' });
    }
    addCategory(postData): Observable<any> {
      return this.http.post(AppComponent.baseUrl + API_WINKELS_ENDPOINT+ '/add-category', postData, { responseType: 'text' });
      }
      getCategory(id): Observable<any> {
        return this.http.get(AppComponent.baseUrl + API_WINKELS_ENDPOINT+ '/get-category?id='+id, { responseType: 'text' });
        }
        deleteCategory(id): Observable<any> {
          return this.http.get(AppComponent.baseUrl + API_WINKELS_ENDPOINT+ '/remove-category?id='+id, { responseType: 'text' });
          }
}
